import type { WorkTaskHourRange } from '../../db/work-task-types.js';
export type TaskLanguage = 'de' | 'en';
export const TASK_ENGLISH_LABELS: Record<string, string> = {
  'Abrechenbare Zeit': 'Billable time',
  'Noch nicht vereinbart': 'Not yet agreed',
  'Die Sitzung ist abgelaufen oder Ihr Konto hat keine Berechtigung für diese Aktion. Bitte erneut anmelden oder den Zugriff prüfen. Ihre Eingaben bleiben erhalten.':
    'Your session has expired or your account does not have permission for this action. Please sign in again or check your access. Your entries have been kept.',

  'Alle aktuellen Tasks': 'All current tasks',
  'Abrechnungsdatum bearbeiten': 'Edit billing date',
  'Abrechnungsdatum speichern': 'Save billing date',
  'Abrechnungsdatum gespeichert.': 'Billing date saved.',

  'ohne Abrechnungsvereinbarung': 'without a billing agreement',
  'Im PDF: ausdrücklich kostenpflichtig vereinbarte Features ab Implemented mit Abrechnungsdatum. Bugs und kostenlose Features sind ausgeschlossen. Die Stundensumme oben gilt dagegen für alle vereinbarten Tasks.':
    'PDF: explicitly agreed billable features from Implemented onwards with a billing date. Bugs and free features are excluded. The hours total above covers all agreed tasks.',

  'Offene abrechenbare Stunden': 'Unpaid billable hours',
  Vereinbart: 'Approved',
  'Kostenpflichtige Tasks erst nach Zahlung archivieren. Archivierte Tasks vor einer Änderung der Zahlung oder offenen Abrechnung wiederherstellen.':
    'Archive billable tasks only after payment. Restore archived tasks before changing payment or unpaid billing.',
  'Archivieren erst nach Zahlungseingang.': 'Archive after payment has been received.',
  'Vor einer Änderung der Zahlung den Task wiederherstellen.': 'Restore the task before changing its payment status.',

  'Feature · Abrechnung separat': 'Feature · billing agreed separately',
  'Vereinbarte abrechenbare Stunden': 'Approved billable hours',
  'Alle Tasks · unabhängig von Status und Filtern': 'All tasks · independent of stage and filters',
  'Noch nicht bezahlt': 'Unpaid',
  Bezahlt: 'Paid',
  'Nicht kostenpflichtig': 'Non-billable',
  'Vereinbart kostenpflichtig': 'Agreed billable',
  'Abrechnung noch offen': 'Billing undecided',
  'In Produktion abgeschlossen': 'Completed in production',
  'Produktion bestätigt. Der Task steht jetzt unter „Abgeschlossen“.':
    'Production completion recorded. The task is now under “Completed”.',
  'Zur Veröffentlichung freigegeben. Die Produktion ist noch nicht bestätigt.':
    'Approved for release. Production completion has not been confirmed.',
  'Bitte ganze Stunden und Minuten (0–59) sowie den Beleg zur Vereinbarung eintragen.':
    'Enter whole hours and minutes (0–59), plus the source of the agreement.',
  'Abrechnungsvereinbarung gespeichert.': 'Billing agreement saved.',
  'Zahlung ausdrücklich bestätigt.': 'Payment explicitly confirmed.',
  'Zahlungsmarkierung aufgehoben.': 'Payment marking removed.',
  Abrechnungsvereinbarung: 'Billing agreement',
  'Arbeitsaufwand und Freigabe sind keine Abrechnungsvereinbarung. Kostenlose Features bleiben Features.':
    'Work estimates and planning approvals do not establish a charge. Free features remain features.',
  'Erfasst am': 'Recorded on',
  'Bezahlt · nur nach tatsächlichem Zahlungseingang markieren': 'Paid · mark only after payment has been received',
  'Zahlung erfasst am': 'Payment recorded on',
  Stunden: 'Hours',
  Minuten: 'Minutes',
  'Vereinbarung / Beleg': 'Agreement / source',
  'z. B. mit Michael vereinbart, E-Mail vom …': 'e.g. agreed with Michael, email dated …',
  'Vereinbart am (optional)': 'Agreement date (optional)',
  'Nur eine tatsächlich getroffene Vereinbarung erfassen. Speichern markiert nichts als bezahlt.':
    'Record only an agreement that was actually made. Saving does not mark anything as paid.',
  'Vereinbarung speichern': 'Save agreement',
  'Vereinbarung bearbeiten': 'Edit agreement',
  'Vor einer Änderung der Vereinbarung zuerst die Zahlungsmarkierung ausdrücklich aufheben.':
    'Explicitly remove the paid marking before changing the agreement.',
  'Zuerst eine kostenpflichtige Vereinbarung mit Stunden dokumentieren.':
    'Record a billable agreement and hours first.',
  'Produktion bestätigt am': 'Production completion recorded on',
  'Frühere Abschlussmarkierung (keine Produktionsbestätigung)':
    'Earlier completion marking (not confirmation of production)',
  'Nur ausdrücklich vereinbarte Beträge · keine automatische Rechnungs- oder Zahlungsbestätigung':
    'Explicit agreements only · no automatic invoice or payment confirmation',
  'Freigabe zur Veröffentlichung und Abschluss in Produktion sind getrennte Schritte.':
    'Release approval and production completion are separate stages.',
  'Nur ausdrücklich als in Produktion abgeschlossen markierte Tasks erscheinen hier.':
    'Only tasks explicitly marked as completed in production appear here.',
  'Filter gelten für Karten und Spaltenzähler. Abrechenbare Stunden oben: alle Tasks, auch abgeschlossen oder archiviert. PDF: eigener Zeitraum.':
    'Filters apply to cards and column counts. Billable hours above cover all tasks, including completed and archived tasks. PDF uses its own period.',
  'Nur ausdrücklich kostenpflichtig vereinbarte Features mit Abrechnungsdatum. Bugs und kostenlose Features sind ausgeschlossen. Listenfilter und Fertigstellung ändern die Vereinbarung nicht.':
    'Only explicitly agreed billable features with a billing date. Bugs and free features are excluded. List filters and completion do not change the agreement.',
  'Abrechnungsvereinbarung und Zahlung werden separat in den Task-Details verwaltet. Diese Bearbeitung verändert sie nicht.':
    'Billing agreements and payments are managed separately in the task details. This edit does not change them.',
  'Abrechnungsdatum für PDF (optional)': 'Billing date for PDF (optional)',
  'Dieses Datum ordnet den Task im PDF-Bericht einem Zeitraum zu; es bestätigt keine Rechnung oder Zahlung.':
    'This date assigns the task to a period in the PDF report; it does not confirm an invoice or payment.',
  'Planungsfreigabe · keine Abrechnungsvereinbarung': 'Planning approval · not a billing agreement',
  'Neue Funktion · kostenlos oder nach Vereinbarung': 'New functionality · free or as agreed',
  'Planungsfreigabe, Abrechnungsvereinbarung und Zahlung werden separat dokumentiert.':
    'Planning approval, billing agreement and payment are recorded separately.',
  'Bis zu 1.000 Tasks werden angezeigt; Suche und Filter beziehen sich auf die geladenen Karten. Die abrechenbaren Stunden werden über alle Tasks berechnet.':
    'Up to 1,000 tasks are shown; search and filters apply to loaded cards. Billable hours are calculated across all tasks.',
  'Suche & Filter': 'Search & filters',
  Verantwortlich: 'Responsible',
  'Nicht zugewiesen': 'Unassigned',
  'Bisherige Zuordnung': 'Previous assignment',
  'Konto nicht aktiv': 'Account inactive',
  Testanleitung: 'How to test',
  'Voraussetzungen / Testkonto, Schritte und erwartetes Ergebnis…':
    'Prerequisites / test account, steps and expected result…',
  'Im Staging-Test sichtbar. Anleitung und Zuordnung ändern weder Umfang noch Freigabe.':
    'Visible during staging tests. Instructions and assignment do not change the scope or approval.',
  'Noch keine Testanleitung hinterlegt.': 'No test instructions provided yet.',
  'Testanleitung öffnen': 'Open test instructions',
  'Testanleitung fehlt': 'Test instructions missing',
  'Nächster Schritt: Staging-Test durch das Testteam': 'Next: testing by the test team',
  'Nächster Schritt: Staging-Test vorbereiten': 'Next: prepare staging test',
  'Nächster Schritt: Freigabe durch Michael / Herrn Brenner': 'Next: approval by Michael / Mr Brenner',
  'Nächster Schritt: Planung ergänzen': 'Next: complete planning',
  'Nächster Schritt: Umsetzung': 'Next: implementation',
  Darstellung: 'View',
  Board: 'Board',
  Liste: 'List',
  'Karte öffnen für Planung, Testanleitung und Aktionen.': 'Open a card for planning, test instructions and actions.',
  'Verantwortliche filtern': 'Filter by owner',
  'Alle Verantwortlichen': 'All owners',
  'Mir zugewiesen': 'Assigned to me',
  'Zieldatum filtern': 'Filter by target date',
  'Alle Termine': 'All target dates',
  Überfällig: 'Overdue',
  'Ohne Zieldatum': 'No target date',
  'Filter zurücksetzen': 'Reset filters',
  'Filter gelten für Karten und Spaltenzähler. Kennzahlen oben: alle offenen Tasks. PDF: eigener Abrechnungszeitraum.':
    'Filters apply to cards and column counts. Top totals cover all open tasks. PDF uses its own billing period.',
  'Aufgaben nach Status': 'Tasks by stage',
  'Details öffnen': 'Open details',
  'Keine Tasks in diesem Schritt': 'No tasks at this stage',
  'Bitte wählen Sie ein aktives Benutzerkonto als Verantwortlichen.': 'Select an active user account as the owner.',
  Implemented: 'Implemented · ready for testing',

  Abbrechen: 'Cancel',
  Aktiv: 'Active',
  Abgeschlossen: 'Completed',
  Archiv: 'Archive',
  Archiviert: 'Archived',
  Archivieren: 'Archive',
  Wiederherstellen: 'Restore',
  'Task-Bereiche': 'Task views',
  'Archivierung bestätigen': 'Confirm archiving',
  'Task archivieren?': 'Archive this task?',
  'Zur Veröffentlichung freigegebene Tasks finden Sie auch unter „Abgeschlossen“.':
    'Tasks approved for release also appear under “Completed”.',
  'Abgeschlossene Tasks bleiben mit allen Angaben erhalten und können bei Bedarf wieder geöffnet werden.':
    'Completed tasks retain all their details and can be reopened if needed.',
  'Archivierte Tasks bleiben erhalten. Beim Wiederherstellen gilt wieder ihr bisheriger Status.':
    'Archived tasks are retained. Restoring a task returns it to its previous stage.',
  'Der PDF-Bericht berücksichtigt auch abgeschlossene und archivierte Features nach denselben Abrechnungsregeln.':
    'The PDF also includes completed and archived Features under the same billing rules.',
  'Task abgeschlossen. Sie finden ihn unter „Abgeschlossen“.': 'Task completed. You can find it under “Completed”.',
  'Task archiviert. Im Archiv können Sie ihn jederzeit wiederherstellen.':
    'Task archived. You can restore it from the Archive at any time.',
  'Task wiederhergestellt. Sie finden ihn unter „Abgeschlossen“.': 'Task restored. You can find it under “Completed”.',
  'Task wiederhergestellt. Sie finden ihn unter „Aktiv“.': 'Task restored. You can find it under “Active”.',
  'Das Archiv ist leer': 'The archive is empty',
  'Noch keine abgeschlossenen Tasks': 'No completed tasks yet',
  'Keine aktiven Tasks': 'No active tasks',
  'Nicht mehr benötigte Tasks können Sie über „Archivieren“ hier ablegen.':
    'Move tasks you no longer need here using “Archive”.',
  'Von ZwickRoell getestete und zur Veröffentlichung freigegebene Tasks erscheinen automatisch hier.':
    'Tasks tested by ZwickRoell and approved for release appear here automatically.',
  'Der Task verschwindet aus dieser Liste. Angaben, Stunden, Termine und Feedback bleiben erhalten. Im Archiv können Sie ihn wiederherstellen.':
    'The task will leave this list. Details, hours, dates and feedback are retained. You can restore it from the Archive.',
  Erstellt: 'Created',
  'Zuletzt abgeschlossen': 'Last completed',
  'Abschlussdatum nicht erfasst': 'Completion date not recorded',
  'Archiviert am': 'Archived on',
  'Ready to production': 'Ready for production · Completed',
  'Abrechenbare Features im gewählten Zeitraum': 'Billable features in the selected period',
  Abrechnung: 'Billing',
  'Abrechnung & PDF': 'Billing & PDF',
  'Abrechnungs-PDF herunterladen': 'Download billing PDF',
  'Abrechnungsbericht als PDF erstellt. Die Tasks wurden nicht als abgerechnet markiert.':
    'Billing PDF created. Tasks have not been marked as billed.',
  'Abrechnungsdaten werden beim Speichern entfernt.': 'Billing details will be removed when you save.',
  Abrechnungsdatum: 'Billing date',
  'Abrechnungsdatum noch offen': 'Billing date not set',
  'Alle Klassifikationen': 'All classifications',
  'Alle Freigaben': 'All approvals',
  'Alle Prioritäten': 'All priorities',
  'Alle Status': 'All stages',
  'Alles für Analyse kopieren': 'Copy everything for analysis',
  'Als TXT speichern': 'Save as TXT',
  'Analysepaket bereit. Bitte „Text kopieren“ oder „Als TXT speichern“ wählen.':
    'Analysis package ready. Choose “Copy text” or “Save as TXT”.',
  'Analysepaket konnte nicht erstellt werden. Bitte erneut versuchen.':
    'Could not prepare the analysis package. Please try again.',
  'Analysepaket kopiert.': 'Analysis package copied.',
  'Analysepaket wird zusammengestellt…': 'Preparing analysis package…',
  Angeheftet: 'Pinned',
  Anheften: 'Pin',
  'Anruf-ID oder Link aus diesem System': 'Call ID or link from this environment',
  Arbeitsplanung: 'Task planning',
  'Arbeitsstatus filtern': 'Filter by stage',
  Aufgabe: 'Task details',
  'Klassifikation *': 'Classification *',
  'Klassifikation filtern': 'Filter by classification',
  'Klassifikation noch offen': 'Classification not set',
  'Klassifikation, Beschreibung und gegebenenfalls Schätzung ergänzen.':
    'Add a classification, description and estimate where required.',
  'Aufwand schätzen': 'Effort estimate',
  Bearbeiten: 'Edit',
  'Beobachtung zuordnen': 'Link an observation',
  'Bereit zur Freigabe': 'Ready for approval',
  'Beschreibung & Umfang': 'Description & scope',
  'Bis (optional)': 'To (optional)',
  'Bis einschließlich': 'To (inclusive)',
  'Bis zu 1.000 Tasks werden angezeigt; angeheftete Tasks stehen zuerst. Suche, Filter und Kennzahlen beziehen sich auf diese geladenen Tasks.':
    'Up to 1,000 tasks are shown, pinned tasks first. Search, filters and totals apply to the loaded tasks.',
  'Bitte auswählen…': 'Please select…',
  'Bitte eine Anruf-ID oder einen Anruf-Link aus diesem System eingeben.':
    'Enter a call ID or a call link from this environment.',
  'Bitte laden Sie die Seite neu. Diese Planung verwendet neue Schätzfelder.':
    'Please reload the page to use the updated planning fields.',
  'Bitte ordnen Sie den Task zuerst als Bug oder Feature ein.': 'Classify the task as a Bug or Feature first.',
  'Bitte prüfen Sie Titel, Klassifikation, Stunden und Datum. Das Stundenmaximum darf nicht unter dem Minimum liegen.':
    'Check the title, classification, hours and date. Maximum hours cannot be less than minimum hours.',
  'Bitte prüfen Sie die Angaben. Titel, Beschreibung und Stunden müssen gültig sein.':
    'Check that the title, description and hours are valid.',
  'Bitte speichern oder schließen Sie zuerst die offene Bearbeitung. Erstellen Sie den neuen Task anschließend erneut über das Feedback.':
    'Save or close the current edit first, then create the new task from the feedback again.',
  'Bitte wählen Sie einen gültigen Zeitraum. „Bis“ darf nicht vor „Von“ liegen.':
    'Select a valid period. “To” cannot be before “From”.',
  'Bug · nicht kostenpflichtig': 'Bug · not chargeable',
  'Bugs werden für den Kunden kostenfrei behoben. Nur Features können im Abrechnungsbericht erscheinen.':
    'Bugs are fixed without a customer charge. Only Features can appear in the billing report.',
  'Der Bericht ist zu groß. Bitte wählen Sie einen kürzeren Zeitraum.':
    'The report is too large. Select a shorter period.',
  'Der PDF-Bericht ist eine Abrechnungsgrundlage mit Stunden, kein Rechnungsbeleg. Ein erneuter Export markiert oder berechnet keine Tasks automatisch.':
    'This hours report is a billing reference, not an invoice. Exporting it again does not mark or charge tasks automatically.',
  'Der Umfang wird noch ergänzt.': 'Scope has not been added yet.',
  'Die Aktion konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut. Der bisherige Stand bleibt erhalten.':
    'The action could not be completed. Please try again. Your previous data is unchanged.',
  'Die Schätzung bleibt offen und wird nicht als 0 Stunden gewertet.':
    'The estimate remains open and is not counted as zero hours.',
  'Die Task-Liste ist unvollständig. Für eine verlässliche Vorschau und den PDF-Export müssen alle Tasks geladen sein.':
    'The task list is incomplete. All tasks must be loaded for an accurate preview and PDF export.',
  'Die Zustimmung von Michael oder Herrn Brenner dokumentieren.': 'Record the approval given by Michael or Mr Brenner.',
  'Die Zustimmung von Michael oder Herrn Brenner wird nach dem Speichern dokumentiert.':
    'Approval from Michael or Mr Brenner is recorded after saving.',
  'Die aktuelle Planung muss zuerst von Michael oder Herrn Brenner freigegeben werden.':
    'The current plan needs approval from Michael or Mr Brenner first.',
  'Die ursprüngliche Beobachtung bleibt erhalten. Bei einem bereits freigegebenen Task erfordert die zusätzliche Verknüpfung eine neue Freigabe.':
    'The original observation is preserved. Adding a link to an approved task requires a new approval.',
  'Dieser Task wurde zwischenzeitlich geändert. Laden Sie die Liste neu und öffnen Sie den aktuellen Task erneut. Ihre Eingaben bleiben bis dahin erhalten.':
    'This task has changed. Reload the list and reopen the current task. Your inputs are preserved until then.',
  'Dieses Datum bestimmt den PDF-Zeitraum. Beide Felder bleiben bis zur Abrechnung optional.':
    'This date determines the PDF reporting period. Both fields remain optional until billing.',
  'Dieses Feedback ist nicht mehr verfügbar. Bitte prüfen Sie den Eintrag in der Feedback-Liste.':
    'This feedback is no longer available. Check its entry in the feedback list.',
  'Erfassen Sie, wer die Planung freigegeben hat. Ihr angemeldetes Konto und der Zeitpunkt werden zusätzlich protokolliert.':
    'Record who approved this plan. Your signed-in account and the time are recorded separately.',
  'Erstellen Sie einen Task direkt oder übernehmen Sie eine Beobachtung aus dem Feedback.':
    'Create a task directly or link an observation from feedback.',
  'Ersten Task erstellen': 'Create the first task',
  'Export abgebrochen.': 'Export cancelled.',
  'Export wird abgebrochen…': 'Cancelling export…',
  'Feature · kostenpflichtig': 'Feature · chargeable',
  'Features nach Abrechnungsdatum zusammenstellen': 'Prepare features by billing date',
  'Feedback & Anrufe': 'Feedback & calls',
  'Feedback kann nach dem Speichern aus der Feedback-Liste zugeordnet werden.':
    'You can link feedback from the feedback list after saving.',
  'Feedback mit dem Task verknüpft.': 'Feedback linked to the task.',
  'Feedback mit einem Task verknüpfen': 'Link feedback to a task',
  'Feedback verknüpfen': 'Link feedback',
  'Feedback zum Zeitpunkt der Verknüpfung': 'Feedback at the time it was linked',
  'Feedback-Auszug': 'Feedback excerpt',
  'Feedback, Task und Gespräch / Logs · ohne Stunden': 'Feedback, task and conversation / logs · without hours',
  'Feste Stunden oder eine Spanne. „Bis“ bleibt bei einem festen Wert leer.':
    'Enter fixed hours or a range. Leave “To” empty for a fixed value.',
  'Finale Abrechnung': 'Final billing',
  'Finale Stunden': 'Final hours',
  'Finale abrechenbare Stunden': 'Final billable hours',
  'Finale abrechenbare Stunden und Abrechnungsdatum gelten nur für Features. Wenn Sie vor dem Speichern wieder Feature wählen, bleiben Ihre Eingaben erhalten.':
    'Final billable hours and billing date apply only to Features. Switching back to Feature before saving preserves your inputs.',
  'Freigabe ausstehend': 'Approval pending',
  'Freigabe dokumentieren': 'Record approval',
  'Freigabe dokumentiert. Status: Approved.': 'Approval recorded. Stage: Approved.',
  'Freigabe erfassen': 'Record approval',
  'Freigabe filtern': 'Filter by approval',
  'Freigabe optional. Fortschritt manuell aktualisieren.': 'Approval is optional. Update progress manually.',
  'Freigabe speichern': 'Save approval',
  'Freigaben: Michael / Herr Brenner · von angemeldeten Nutzern dokumentiert':
    'Approvals: Michael / Mr Brenner · recorded by signed-in users',
  Freigegeben: 'Approved',
  'Freigegeben von': 'Approved by',
  'Für diesen Zeitraum liegen noch keine abrechenbaren Features vor.':
    'No billable features are available for this period yet.',
  'Für eine Freigabe werden eine Klassifikation und eine Beschreibung benötigt. Features benötigen zusätzlich eine Schätzung über 0 Stunden.':
    'Approval requires a classification and description. Features also need an estimate above zero hours.',
  'Gemeinsam weiterentwickeln': 'Improve together',
  'Geplant und in Umsetzung': 'Planned and being implemented',
  'Geschätzte Stunden · offene Tasks': 'Estimated hours · open tasks',
  'Gesamt inklusive Testing': 'Total including testing',
  'Gesamter Umfang inklusive Testing. Aufteilung siehe Beschreibung.':
    'Total scope including testing. See the description for the breakdown.',
  'Geschätzter Aufwand': 'Estimated effort',
  Gesamtaufwand: 'Total effort',
  'ID wird beim Speichern vergeben': 'ID assigned on save',
  'Ihr Konto kann keine Freigabe dokumentieren.': 'Your account cannot record approvals.',
  'Ihr angemeldetes Konto hat keine Berechtigung für diese Aktion.':
    'Your signed-in account does not have permission for this action.',
  'Im PDF: freigegebene Features ab': 'Included in the PDF: approved Features from',
  'Keine passenden Tasks': 'No matching tasks',
  'Kopieren ist hier nicht verfügbar. Das Analysepaket kann als TXT gespeichert werden.':
    'Copying is unavailable here. You can save the analysis package as TXT.',
  'Lädt…': 'Loading…',
  'Michael / Herr Brenner': 'Michael / Mr Brenner',
  'Nach Abschluss die tatsächlich zu berechnenden Stunden eintragen. Schätzungen werden nicht übernommen.':
    'After completion, enter the actual hours to charge. Estimates are not copied into billing.',
  'Nach Tätigkeiten': 'By activity',
  'Neu laden': 'Reload',
  'Neuen Task erstellen': 'Create a task',
  'Neuer Entwurf': 'New draft',
  'Neuer Task': 'New task',
  'Noch kein Feedback verknüpft': 'No feedback linked yet',
  'Noch keine Tasks vorhanden. Erstellen Sie zuerst einen neuen Task.':
    'There are no tasks yet. Create a new task first.',
  'Noch nicht festgelegt': 'Not set',
  'Noch nicht zugeordnet': 'Not classified yet',
  'Noch offen': 'Not set',
  Offen: 'Open',
  'Nur die Projektverantwortlichen können Tasks erstellen und Feedback verknüpfen.':
    'Only project managers can create tasks and link feedback.',
  'Nur freigegebene Features ab Implemented mit finalen abrechenbaren Stunden. Bugs und nicht zugeordnete Tasks sind ausgeschlossen. Alle passenden Tasks werden berücksichtigt, unabhängig von den Listenfiltern.':
    'Only approved Features from Implemented onwards with final billable hours are included. Bugs and unclassified tasks are excluded. All matching tasks are included regardless of the list filters.',
  'Oben anheften': 'Pin to top',
  'Offene Tasks': 'Open tasks',
  'Optional. Ohne Datum steht auf der Karte „Noch nicht festgelegt“.':
    'Optional. The card shows “Not set” when no date is selected.',
  'PDF wird erstellt…': 'Creating PDF…',
  'Passen Sie die Suche oder die Filter an.': 'Adjust the search or filters.',
  Planung: 'Planning',
  'Planung aktualisieren': 'Update planning',
  'Planung noch unvollständig': 'Planning is incomplete',
  'Platz für die nächsten Verbesserungen': 'A place for the next improvements',
  Priorität: 'Priority',
  'Priorität filtern': 'Filter by priority',
  'Recherche und Budget noch abzustimmen. Nicht in der Stundensumme enthalten.':
    'Research and budget are still to be agreed. Not included in the hours total.',
  Recherche: 'Research',
  Entwicklung: 'Development',
  Schließen: 'Close',
  Schätzung: 'Estimate',
  'Sortierung gespeichert.': 'Ordering saved.',
  'Speichert…': 'Saving…',
  'Status aktualisiert.': 'Stage updated.',
  'Stunden / von': 'Hours / from',
  'Task auswählen…': 'Select a task…',
  'Task bearbeiten': 'Edit task',
  'Task für Analyse kopieren': 'Copy task for analysis',
  'Task gespeichert.': 'Task saved.',
  'Task speichern': 'Save task',
  'Tasks & Abrechnung': 'Tasks & billing',
  'Tasks durchsuchen': 'Search tasks',
  'Tasks konnten nicht geladen werden. Bitte erneut laden. Ihr Feedback ist weiterhin verfügbar.':
    'Tasks could not be loaded. Please reload. Your feedback is still available.',
  'Tasks werden geladen…': 'Loading tasks…',
  'Text kopieren': 'Copy text',
  'Titel *': 'Title *',
  Verknüpfen: 'Link',
  'Verknüpftes Feedback zur ursprünglichen Beobachtung.': 'Linked feedback for the original observation.',
  'Verknüpft…': 'Linking…',
  Von: 'From',
  'Von der Beobachtung zur Umsetzung. Aufgaben planen, Arbeitsstunden abstimmen und Fortschritte gemeinsam verfolgen.':
    'From observation to implementation. Plan tasks, agree effort and track progress together.',
  'Vorhandener Task': 'Existing task',
  'Warten auf Freigabe': 'Awaiting approval',
  'Zeitraum prüfen': 'Check period',
  'inklusive Testing. Target release:': 'including testing. Target release:',
  'mit finalen Stunden und Abrechnungsdatum.': 'with final hours and a billing date.',
  'verknüpfte Feedbacks': 'linked feedback entries',
  'verknüpftes Feedback': 'linked feedback entry',
  'Änderungen an Titel, Umfang, Klassifikation, Schätzung oder Target release setzen den Status auf Acknowledged und erfordern eine neue Freigabe. Finale Abrechnungsdaten, Priorität und Anheften bleiben davon unabhängig.':
    'Changes to the title, scope, classification, estimate or target release reset the stage to Acknowledged and require a new approval. Final billing details, priority and pinning are independent.',
  'Voraussichtliche Dauer': 'Estimated completion time',
  'z. B. 2–3 Arbeitstage nach Freigabe': 'e.g. 2–3 working days after approval',
  Terminplanung: 'Schedule',
  'Kalendertermin und Dauer sind unabhängig vom geschätzten Arbeitsaufwand.':
    'The target date and completion timeframe are separate from estimated work hours.',
  'Für Bugs und Features: die erwartete Kalenderdauer, zum Beispiel 2–3 Arbeitstage.':
    'For Bugs and Features: the expected elapsed time, for example 2–3 working days.',
  '+ Feedback hinzufügen': '+ Add feedback',
  'Was soll verbessert oder umgesetzt werden?': 'What should be improved or implemented?',
  'Beobachtung, gewünschte Änderung und Abnahmekriterien…': 'Observation, requested change and acceptance criteria…',
  'gleicher Wert': 'same value',
  'Task-ID, Titel, Feedback oder Anruf…': 'Task ID, title, feedback or call…',
  'Geplante Arbeiten und Freigaben': 'Planned work and approvals',
  'Task-Übersicht': 'Task overview',
  'Nicht im Bericht enthalten': 'Excluded from this report',
  Stundenschätzung: 'Effort estimate',
  'Freigabe bestätigen': 'Confirm approval',
  Aktualisieren: 'Refresh',
  'ohne finale Stunden': 'missing final hours',
  'ohne Abrechnungsdatum': 'missing billing date',
  'ohne aktuelle Freigabe': 'without current approval',
  'noch nicht implementiert': 'not implemented yet',
  'Bugs · nicht kostenpflichtig': 'Bugs · non-billable',
  'noch nicht zugeordnet': 'not classified yet',
  'außerhalb des Zeitraums': 'outside the selected period',
  'mit unvollständigen Aufgabendaten': 'with incomplete task details',
  'Davon abrechenbar': 'Of which billable',
  'Nur Features': 'Features only',
  'ohne Schätzung': 'without estimates',
  'Planungsschätzung · keine finale Abrechnung': 'Planning estimate · not final billing',
  'Unvollständige Liste – Stundensummen nicht verfügbar.': 'Incomplete list – hour totals unavailable.',
  Gesamt: 'Total',
  Aktualisiert: 'Updated',
  'Beschriebener Umfang:': 'Described scope:',
  Anruf: 'Call',
  'öffnen ↗': 'open ↗',
  'Der Anruf muss Feedback enthalten.': 'The call must contain feedback.',
  'Eine neue Verknüpfung setzt die Freigabe zurück.': 'A new link resets approval.',
  '· bereits verknüpft': '· already linked',
  '· gekürzt': '· truncated',
  'Sprache der Tasks': 'Task language',
  'Englische Ansicht wird vorbereitet. Originaltext wird angezeigt.':
    'Preparing the English view. Showing original text.',
  'Übersetzung nicht verfügbar. Originaltext wird angezeigt.': 'Translation is unavailable. Showing original text.',
  'Erneut übersetzen': 'Retry translation',
  'Englische Übersetzung · Original oben': 'English translation · original above',
  'Englische Ansicht · Originaldaten bleiben unverändert': 'English view · original data stays unchanged',
  'Bearbeitungsfelder enthalten den Originaltext. Übersetzungen dienen nur zur Ansicht.':
    'Editing fields contain the original text. Translations are for viewing only.',
  'Der PDF-Bericht wird auf Deutsch mit Originaltiteln erstellt. Analysepakete enthalten die ursprünglichen Belege.':
    'The PDF remains in German with original titles. Analysis packages retain the original evidence.',
  'Übersetzung nicht mehr aktuell, da der Entwurf geändert wurde.':
    'The translation is out of date because this draft was edited.',
  'Nächster Schritt: Staging-Test durch ZwickRoell': 'Next step: staging testing by ZwickRoell',
  'Nächster Schritt: Freigegebene Version bereitstellen': 'Next step: deploy the approved release',
  'Geschätzte Feature-Stunden': 'Estimated feature hours',
  'Nur offene Features · Bugs ausgeschlossen': 'Open features only · Bugs excluded',
  'Features ohne Schätzung': 'features awaiting estimate',
  'Noch nicht geschätzt': 'Not estimated yet',
  'Spanne hinzufügen (optional)': 'Add range (optional)',
  'Eine Gesamtzahl genügt. Spanne und Aufteilung nach Tätigkeiten sind optional.':
    'One total is enough. A range and breakdown by activity are optional.',
  'Fehler beheben · ohne Kundenberechnung': 'Fix a defect · no customer charge',
  'Neue Funktion · Freigabe zur Abrechnung erforderlich': 'New functionality · billing approval required',
  'Bitte Bug oder Feature auswählen.': 'Please select Bug or Feature.',
  'Erwarteter Lieferzeitraum': 'Expected delivery timeframe',
  'Testanleitung vorhanden': 'Test instructions saved',
  'Optional: Schritte und erwartetes Ergebnis': 'Optional: steps and expected result',
  'Noch keine finalen Stunden': 'No final hours entered',
  'Getrennt von der Schätzung': 'Separate from the estimate',
  'Priorität & Klassifikation': 'Priority & classification',
  Originaltext: 'Original text',
  'Bereits verknüpft': 'Already linked',
};
const german: Record<string, string> = {
  'Completed in production': 'In Produktion abgeschlossen',
  Raised: 'Erfasst',
  Acknowledged: 'Zur Kenntnis genommen',
  Approved: 'Freigegeben',
  Implemented: 'Umgesetzt · bereit zum Test',
  'In progress': 'In Bearbeitung',
  'Test staging': 'Staging-Test',
  'Awaiting ZwickRoell testing': 'Wartet auf Test durch ZwickRoell',
  'Tested by ZwickRoell — Approved for release': 'Von ZwickRoell getestet · zur Veröffentlichung freigegeben',
  'Ready to production': 'Abgeschlossen · bereit für Produktion',
  High: 'Hoch',
  Medium: 'Mittel',
  Low: 'Niedrig',
  'Target release': 'Zieldatum',
};
export function taskUiText(language: TaskLanguage, text: string): string {
  const normalizedText = text.replace(/\s+/g, ' ').trim();
  const normalized =
    Object.keys(TASK_ENGLISH_LABELS).find(key => TASK_ENGLISH_LABELS[key] === normalizedText) ?? normalizedText;
  if (language === 'de') return german[normalized] ?? (normalized !== normalizedText ? normalized : text);
  if (TASK_ENGLISH_LABELS[normalized]) return TASK_ENGLISH_LABELS[normalized]!;
  const loading = normalized.match(/^Tasks und Feedback laden… \((\d+)\)$/);
  if (loading) return `Loading tasks and feedback… (${loading[1]})`;
  const call = normalized.match(/^Anruf (\d+) von (\d+): Gespräch, Feedback und Logs…$/);
  if (call) return `Call ${call[1]} of ${call[2]}: conversation, feedback and logs…`;
  for (const [source, english] of Object.entries(TASK_ENGLISH_LABELS)) {
    const prefix = normalized.startsWith(source + ' ') ? source : normalized.startsWith(english + ' ') ? english : null;
    if (prefix && /[.!…]$/.test(prefix))
      return english + ' ' + taskUiText(language, normalized.slice(prefix.length + 1));
  }
  const missing = normalized.match(/^(\d+) Abschnitte fehlen und sind im Text markiert\.$/);
  if (missing) return `${missing[1]} sections are missing and are marked in the text.`;
  return text;
}
export function taskUiHours(language: TaskLanguage, value: WorkTaskHourRange | null): string {
  if (!value) return taskUiText(language, 'Offen');
  const format = (n: number) =>
    new Intl.NumberFormat(language === 'de' ? 'de-DE' : 'en-GB', { maximumFractionDigits: 2 }).format(n);
  return (value.min === value.max ? format(value.min) : `${format(value.min)}–${format(value.max)}`) + ' h';
}
export function taskUiCalendarDate(language: TaskLanguage, value: string | null | undefined): string {
  if (!value) return taskUiText(language, 'Noch nicht festgelegt');
  const parsed = new Date(value + 'T12:00:00Z');
  if (!Number.isFinite(parsed.getTime())) return taskUiText(language, 'Noch nicht festgelegt');
  return parsed.toLocaleDateString(language === 'de' ? 'de-DE' : 'en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
export function taskUiTimestamp(language: TaskLanguage, value: string | Date): string {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime())
    ? '—'
    : parsed.toLocaleString(language === 'de' ? 'de-DE' : 'en-GB', { dateStyle: 'short', timeStyle: 'short' });
}
